import { Resource } from 'constants/resources';

import {
  ReferenceArrayField as RaReferenceArrayField,
  ReferenceArrayFieldProps as RaReferenceArrayFieldProps,
} from 'react-admin';

export type ReferenceArrayFieldProps = RaReferenceArrayFieldProps & {
  reference: Resource;
};

export const ReferenceArrayField: React.FC<ReferenceArrayFieldProps> = (props) => {
  return <RaReferenceArrayField {...props} />;
};
